import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

export default function CallerSettings() {
  const navigate = useNavigate()
  useEffect(() => {
    navigate("/settings/voice")
  }, [navigate])

  return null
}
